// extracted by mini-css-extract-plugin
export default {"image":"Fragment_image__Mugax","small":"Fragment_small__d3IbE","valueLabel":"Fragment_valueLabel__LsChO"};